export default __webpack_public_path__ + "static/media/separator_line_and_text.6c42bf6c.svg";